import { makeStyles, DefaultTheme } from '@material-ui/styles';
import cn from 'clsx';
import { UserPreview } from '../UserTypes';
import UserIcon, { IconSizes } from '../UserIcon';
import UserFullName from '../UserFullName';
import UserJobDetails from '../UserJobDetails';

interface UserHeader {
    user: UserPreview;
    userIconSize?: IconSizes;
    titleVariant?: keyof DefaultTheme['typography'];
    descriptionVariant?: keyof DefaultTheme['typography'];
    hideUserIcon?: boolean;
    hideSocialIcons?: boolean;
}

const useStyles = makeStyles(
    theme => ({
        mainInfo: {
            display: 'flex',
        },
        flexColumn: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            paddingLeft: 12,

            [theme.breakpoints.up('sm')]: {
                paddingLeft: 16,
            },

            '&.without-user-icon': {
                paddingLeft: 0,
            },
        },
    }),
    { classNamePrefix: 'user-info-header' }
);

const UserInfoHeader: React.FC<UserHeader> = ({
    user,
    userIconSize = 'XX-Large',
    titleVariant = 't60',
    descriptionVariant = 't71',
    hideUserIcon = false,
}) => {
    const { firstName = '', lastName = '', title, company, photoUrl } = user;
    const classes = useStyles();

    return (
        <div className={classes.mainInfo}>
            {hideUserIcon ? null : <UserIcon size={userIconSize} photoUrl={photoUrl} />}
            <div className={cn(classes.flexColumn, hideUserIcon && 'without-user-icon')}>
                <UserFullName
                    firstName={firstName}
                    lastName={lastName}
                    variant={titleVariant}
                    clamp={1}
                />
                <UserJobDetails
                    role={title}
                    company={company}
                    variant={descriptionVariant}
                    clamp={2}
                />
            </div>
        </div>
    );
};

export default UserInfoHeader;
